import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import {
    clearTemplateProducts,
    getShippingBatchAllocations,
    resetBatchAllocation,
    resetBomData,
    resetSurgeryDetailsReducer,
    setProgressBarStatus,
    updateMaterialB,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    getCheckOrderActionEligibility,
    getCheckOrderActionEligibilityReset,
} from 'src/pages/orders/redux/actions';
import { stopTimer, getTimerData } from 'src/common/redux/timerActions';
import { formatElapsedTimeHHMMSS } from 'src/utils/timerUtils';
import {
    COUNTRY_CODE_JAPN,
    SCHEDULESURGERYSTEPS,
} from 'src/constants/productConstants';
import { VISIBLE } from 'src/constants/appConstants';
import { ADDPRODUCTMETHODS } from 'src/constants/productConstants';
import UnsavedChanges from './notifications/UnsavedChanges';
import { validateProducts } from 'src/pages/scheduleSurgery/redux/actions';
import {
    changeShippingSegmentIndex,
    resetSurgeryDetails,
    reSetProgressBarStatus,
    disableSurgeryDate,
    currentSurgeryDateSelected,
    putRecentlyUsedPhysicians,
    updateCartDataShipping,
    checkProductBomDetails,
    storeAddItemData,
} from 'src/pages/scheduleSurgery/redux/actions';
import NoInventoryShippingNonTissueSet from 'src/pages/scheduleSurgery/components/surgery/notifications/NoInventoryShippingNonTissueSet';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import {
    checkProductBomDetailsExtracter,
    getQuantityCount,
    isMobileDevice,
    redirectToInitialPath,
    logErrorToConsole,
    isModifyEquity,
    isModifySurgery,
} from 'src/utils/util';
import { useLocation, useHistory } from 'react-router-dom';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { CSR_USER_ROLE } from 'src/constants/appConstants';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import { ENABLED, ENVIRONMENTVARIABLE } from 'src/constants/appConstants';
import { setIsMastOrder, setPediatricCheck } from 'src/common/redux/actions';
import { resetNotes } from 'src/common/redux/actions/index.js';
import { useTranslation } from 'react-i18next';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import {
    AcceptContinueText,
    ButtonTexts,
    ImportantNotice,
    MsgText,
    ProductItem,
    ProductList,
    ResponsiveSpan,
    ReturnToCartText,
} from 'src/pages/scheduleSurgery/components/surgery/SurgeryFooter.styled.jsx';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    normalizeCFN,
    buildSyncedItemsState,
    computeAutoAddItems,
    buildValidateProductsList,
    mergeAddItemRules,
} from 'src/utils/addItemRuleUtils';

function SurgeryFooter({
    tabletPortraitMargin,
    viewTemplate,
    selectedItems,
    disabled,
    createTemplate,
    addProductMethod,
    currentActivity,
    setViewSurgerySuccess,
    saveSurgeryAndExit,
    showSubmit,
    showNext,
    tissuePO,
    nonTissuePO,
    checkPoNumberTissue,
    checkPoNumberNonTissue,
    checkPoNumber,
    nonTissueSetsForInventoryShipping,
    productSearchPagination,
    justifyContent,
    deskMarginRight,
    isCondensedView,
    children,
    zIndex = 2000,
    customStyle = {
        position: 'fixed',
        width: {
            standard: isCondensedView
                ? 'calc(100% - 4.67777rem)'
                : 'calc(100% - 5rem)',
            portraitDevice: '100%',
            smallDevice: '100%',
        },
        padding: '5px',
        inPaddingVertical: '5px',
    },
    count = 0,
    callCreateTemplate = () => {},
    cancelCreateTemplate = () => {},
    isValidProductsItems = () => true,
    addIosPadding = false,
    orderPageMobilePadding,
    footerButtonSize,
    footerButtonMargin,
    sameBatchAllocationError,
    isTransferSurgery,
    orderStatusCode,
    myCaseRefId,
    reviewMandatoryFields,
    setCount,
    cartProductsLength,
    myCaseRef,
    // showAddPopup,
    // setShowAddPopup,
    addItemRules,
    setAddedItemsState = () => {},
    addedItemsState,
    isFromSearchSelectedTemplate = false,
    blockNavigationForDeliveryCheck = false,
    setBlockNavigationForDeliveryCheck = () => {},
}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [cancel, setCancel] = useState(false);
    const [showDeliveryCheckMessage, setShowDeliveryCheckMessage] =
        useState(false);
    // const [saveAndExit, setsaveAndExit] = useState(false);
    const history = useHistory();
    const [onlyNonTissueSets, setOnlyNonTissueSets] = useState(false);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [popupItems, setPopupItems] = useState([]);
    const [pendingPopup, setPendingPopup] = useState(false);
    const [pendingTransferNavigation, setPendingTransferNavigation] = useState(false);
    const [isCheckingEligibility, setIsCheckingEligibility] = useState(false);
    const [isSaveAndExitClicked, setIsSaveAndExitClicked] = useState(false);
    const [isCheckingReviewEligibility, setIsCheckingReviewEligibility] =
        useState(false);

    const { currentSelectedIndex, surgeryDateTime } = useSelector((state) => ({
        currentSelectedIndex: state.surgeryReducer.selectedShippingSegment,
        surgeryDateTime: state.surgeryReducer.surgeryDetails.surgeryDateTime,
    }));

    const { isAllowed, statusCode } = useSelector(
        (state) => state.checkOrderActionEligibilityReducer
    );

    const orderStatus = useSelector(
        (state) =>
            state.surgeryDetailsReducer.surgeryData.orderStatusDescription
    );

    useEffectWithErrorLogging(() => {
        if (isModifySurgery() && isAllowed !== '') {
            if (!isAllowed && statusCode === '13201') {
                // Delivery check message is shown, block navigation and show message
                setBlockNavigationForDeliveryCheck(true);
                setShowDeliveryCheckMessage(true);
            } else if (isAllowed) {
                // Eligibility check passed and no special message, allow navigation
                setBlockNavigationForDeliveryCheck(false);
                setShowDeliveryCheckMessage(false);
            }
        }
    }, [isAllowed, statusCode]);

    const handleRedirectClick = () => {
        history.push(redirectToInitialPath(history));
    };

    const handleCloseDeliveryCheckPopUp = () => {
        dispatch(getCheckOrderActionEligibilityReset());
        handleRedirectClick();
    };

    const checkOrderActionEligibilityResult = useSelector(
        (state) => state.checkOrderActionEligibilityReducer
    );
    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );
    const {
        physicianDropdownSurgeryVisibility,
        isShowBomChanges,
        isLanguageChanged,
    } = useSelector((state) => state.loginReducer);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const { cartData } = useSelector((state) => ({
        cartData: state.surgeryReducer.cartData,
    }));

    const timerData = useSelector((state) => getTimerData(state));

    const addItemData = useSelector(
        (state) => state.storeAddItemDataReducer.addItem
    );

    const validateProductsLoading = useSelector(
        (state) => state.validateProductsReducer.loading
    );

    const { accountError, surgeonError, validatedProducts } = useSelector(
        (state) => state.validateProductsReducer
    );

    // Show popup only after validateProducts loading finishes to avoid black screen overlay
    useEffectWithErrorLogging(() => {
        if (pendingPopup && !validateProductsLoading) {
            setPendingPopup(false);
            setShowAddPopup(true);
        }
    }, [pendingPopup, validateProductsLoading]);

    // Navigate transfer surgery after validateProducts API completes
    useEffectWithErrorLogging(() => {
        if (pendingTransferNavigation && !validateProductsLoading) {
            setPendingTransferNavigation(false);
            const hasValidationErrors =
                accountError?.length > 0 ||
                surgeonError?.length > 0 ||
                (validatedProducts ?? []).some(
                    (p) =>
                        p.isExcluded ||
                        p.isExcludedExtraItem ||
                        p.reservationSetErrorMessage
                );
            if (!hasValidationErrors) {
                dispatch(setProgressBarStatus(SCHEDULESURGERYSTEPS[1]));
            }
        }
    }, [pendingTransferNavigation, validateProductsLoading]);

    const { visualInspectionAcknowledgement, surgeryVisualInspection } =
        useSelector((state) => ({
            visualInspectionAcknowledgement:
                state.surgeryReducer.visualInspectionAcknowledgement,
            surgeryVisualInspection: state.loginReducer.surgeryVisualInspection,
        }));

    useEffectWithErrorLogging(() => {
        if (
            isCheckingEligibility &&
            checkOrderActionEligibilityResult?.isAllowed !== ''
        ) {
            setIsCheckingEligibility(false);
            if (checkOrderActionEligibilityResult?.isAllowed === true) {
                continueClick();
            } else {
            }
        }
        if (
            isCheckingReviewEligibility &&
            checkOrderActionEligibilityResult?.isAllowed !== ''
        ) {
            setIsCheckingReviewEligibility(false);
            if (checkOrderActionEligibilityResult?.isAllowed === true) {
                setViewSurgerySuccess(true);
            } else {
               
            }
        }
        if (
            isSaveAndExitClicked &&
            checkOrderActionEligibilityResult?.isAllowed !== ''
        ) {
            setIsSaveAndExitClicked(false);
            if (checkOrderActionEligibilityResult?.isAllowed === true) {
                saveSurgeryAndExit();
            } else {
            
            }
        }
    }, [
        checkOrderActionEligibilityResult?.isAllowed,
        checkOrderActionEligibilityResult?.statusCode,
        isCheckingEligibility,
    ]);

    useEffectWithErrorLogging(() => {}, [visualInspectionAcknowledgement]);

    useEffectWithErrorLogging(() => {
        setAddedItemsState((prev) =>
            buildSyncedItemsState(cartData?.products ?? [], prev)
        );
    }, [cartData?.products]);

    // product validation
    const validateProductsQuickOrder = (products) => {
        const productsToBeAdded = [...products];
        const filteredProducts = (productsToBeAdded || []).filter(
            (product) => product.quantity > 0
        );
        return filteredProducts;
    };

    const handleDiscardChanges = () => {
        sessionStorage.removeItem('myCaseRefID');
        (myCaseRefId && myCaseRefId?.length > 0) &&
            unlockOrderFunc({
                action:
                    orderStatusCode === '20010'
                        ? 'DraftSurgeryEdit'
                        : 'SubmittedSurgeryEdit',
                myCaseRefId,
            });
        const redirectPath = redirectToInitialPath(history);
        dispatch(resetNotes());
        dispatch(resetSurgeryDetails());
        dispatch(resetSurgeryDetailsReducer());
        dispatch(resetBatchAllocation());
        dispatch(resetBomData());
        dispatch(reSetProgressBarStatus());
        history.push(redirectPath);
        dispatch(setPediatricCheck(''));
        dispatch(setIsMastOrder(false));
        dispatch(storeAddItemData([]));
    };
    const updateStoreAddItem = (itemList) => {
        const merged = mergeAddItemRules(addItemData, itemList);
        if (merged.length > 0) {
            dispatch(storeAddItemData(merged));
        }
    };
    const addItemToCart = (itemList) => {
        const products = buildValidateProductsList(itemList, addItemData);
        updateStoreAddItem(itemList);
        dispatch(
            validateProducts({
                products,
                orderType: 'ZLC',
                searchType: 'productSearch',
                addItemRule: true,
                isFromSurgery: true,
            })
        );
    };

    const continueClick = () => {
        // Block navigation if delivery check message is being shown
        if (blockNavigationForDeliveryCheck) {
            return;
        }

        dispatch(setProgressBarStatus(currentActivity));
        if (physicianDropdownSurgeryVisibility === VISIBLE) {
            dispatch(putRecentlyUsedPhysicians());
        }
        if (currentActivity === SCHEDULESURGERYSTEPS[0]) {
            if (isTransferSurgery) {
                const cartProducts = cartData?.products ?? [];
                if (cartProducts.length > 0) {
                    dispatch(
                        validateProducts({
                            products: cartProducts,
                            orderType: 'ZLC',
                            isCartProductcheck: true,
                            isFromSurgery: true,
                        })
                    );
                    setPendingTransferNavigation(true);
                } else {
                    dispatch(setProgressBarStatus(SCHEDULESURGERYSTEPS[1]));
                }
            } else {
                dispatch(disableSurgeryDate(true));
                if (
                    new Date(
                        new Date(surgeryDateTime).setHours(0, 0, 0, 0)
                    ).getTime() === new Date().setHours(0, 0, 0, 0)
                ) {
                    dispatch(currentSurgeryDateSelected(true));
                } else {
                    dispatch(currentSurgeryDateSelected(false));
                }
            }
        }

        if (currentActivity === SCHEDULESURGERYSTEPS[1]) {            
            const reservationSetCFNs = Array.from(
                new Set(
                    (cartData?.products ?? [])
                        .filter((p) => p?.isReservationSet)
                        .map((p) => (p?.cfn || p?.productCFN))
                        .filter(Boolean)
                )
            );

            if (reservationSetCFNs.length > 0) {
                dispatch(
                    getShippingBatchAllocations({
                        cfn: reservationSetCFNs,
                        isReservationSet: true,
                    })
                );
            }
            return;
        }        
        if (currentActivity === SCHEDULESURGERYSTEPS[3]) {
            setViewSurgerySuccess(true);
            return;
        }

        if (
            !nonTissueSetsForInventoryShipping.nonInventoryShipping &&
            currentActivity === SCHEDULESURGERYSTEPS[2] &&
            nonTissueSetsForInventoryShipping.setsList.length > 0
        )
            dispatch(
                updateCartDataShipping(
                    {
                        shippingRequirement:
                            nonTissueSetsForInventoryShipping.nonInventoryShipping,
                    },
                    nonTissueSetsForInventoryShipping.setsList.map(
                        (set) => set.productKey
                    )
                )
            );
    };
    const {
        procedureTypeConsignmentAdd,
        procedureVisibilityKE,
        deliveryCheckEdit,
        deliveryCheckNoUsageToReport,
    } = useSelector((state) => state.loginReducer);

    const getButtonsBasedOnActivity = (
        viewTemplate,
        selectedItems,
        disabled,
        createTemplate,
        addProductMethod,
        productSearchPagination
    ) => {
        if (productSearchPagination) {
            return children;
        } else if (viewTemplate) {
            return (
                <Button
                    id={'surgery-surgeryfooter-addselectedtocart-button'}
                    show={true}
                    variant={
                       count > 0 && !disabled
                            ? ButtonStyles.primary
                            : ButtonStyles.disabled
                    }
                    // primary={count > 0}
                                       disabled={count === 0 || disabled}
                    width={isLanguageChanged ? 'fit-content' : '210px'}
                    margin={
                        isMobileDevice()
                            ? '10px 0px 4px 0px'
                            : '12px 0px 0px 0px'
                    }
                    mobileWidth={'284px'}
                    height={'38px'}
                    clicked={() => {
                        try {
                        if (count > 0 && !disabled) {
                                isValidProductsItems();
                            }
                            dispatch(clearTemplateProducts());
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    // margin={customStyle.inPaddingVertical}
                    fontSize={'13px'}
                >
                    {t(
                        'scheduleSurgery.surgery.SurgeryFooter.addSelectedToCartButton'
                    )}{' '}
                    ({count})
                </Button>
            );
        } else if (createTemplate) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent:
                            window.innerWidth <= sizes.mobileDevice
                                ? 'space-evenly'
                                : 'flex-end',
                        padding:
                            window.innerWidth <= sizes.mobileDevice
                                ? orderPageMobilePadding
                                    ? orderPageMobilePadding
                                    : '1.125rem 1rem'
                                : '9px 0',
                        width:
                            window.innerWidth <= sizes.mobileDevice
                                ? '100%'
                                : '',
                    }}
                >
                    <Button
                        id={'surgery-createtemplate-surgeryfooter-cancel'}
                        show={true}
                        variant={ButtonStyles?.secondary}
                        //secondary={true}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '122px'
                        }
                        height={'38px'}
                        clicked={cancelCreateTemplate}
                        // margin={'5px'}
                        fontSize={footerButtonSize ? footerButtonSize : '13px'}
                        margin={
                            window.innerWidth <= sizes.mobileDevice
                                ? footerButtonMargin
                                    ? footerButtonMargin
                                    : '0px 0px 4px 0px'
                                : '0px 6px 0px 0px'
                        }
                    >
                        {t('reportUsage.reportUsageFooterbuttons.cancelButton')}
                    </Button>
                    <Button
                        id={'surgery-createtemplate-surgeryfooter-save'}
                        show={true}
                        variant={
                            selectedItems
                                ? ButtonStyles.primary
                                : ButtonStyles.disabled
                        }
                        disabled={!selectedItems}
                        width={
                            window.innerWidth <= sizes.mobileDevice
                                ? '40%'
                                : '122px'
                        }
                        height={'38px'}
                        clicked={callCreateTemplate}
                        // margin={'5px'}
                        fontSize={footerButtonSize ? footerButtonSize : '13px'}
                        //  primary={selectedItems && selectedItems.length}
                        margin={
                            window.innerWidth <= sizes.mobileDevice
                                ? footerButtonMargin
                                    ? footerButtonMargin
                                    : '0px 0px 4px 0px'
                                : '0px 10px 0px 0px'
                        }
                    >
                        {t('scheduleSurgery.surgery.SurgeryFooter.saveBtn')}
                    </Button>
                </div>
            );
        } else if (addProductMethod === ADDPRODUCTMETHODS()[2].name) {
            return (
                <div style={{ display: 'inline-block' }}>
                    <Button
                        id={'surgery-surgeryfooter-addtocart-button'}
                        show={true}
                        // primary={
                        //     getQuantityCount(
                        //         productWithIsPlaceHolderSet &&
                        //             productWithIsPlaceHolderSet?.length > 0
                        //             ? productWithIsPlaceHolderSet?.filter(
                        //                   (item) =>
                        //                       selectedItems.some(
                        //                           (data) => data.cfn != item.cfn
                        //                       )
                        //               )
                        //             : selectedItems
                        //     ) > 0
                        // }
                        disabled={
                            getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            ) === 0
                        }
                        variant={
                            getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            ) > 0
                                ? ButtonStyles?.primary
                                : ButtonStyles?.disabled
                        }
                        width={
                            isLanguageChanged && selectedItems.length > 0
                                ? '197px'
                                : '178px'
                        }
                        mobileWidth={'289px'}
                        height={'38px'}
                        clicked={() => {
                            try {
                                dispatch(
                                    validateProducts({
                                        products:
                                            validateProductsQuickOrder(
                                                selectedItems
                                            ),
                                        orderType: 'ZLC',
                                        isFromSurgery: true,
                                    })
                                );
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        margin={'5px 5px 5px 8%'}
                        mobileMargin={'5px 5px 5px 0%'}
                    >
                        <div style={{ paddingRight: '4px' }}>
                            {t('equity.surgery.addToCart')}
                        </div>
                        {selectedItems.length > 0 && (
                            <div>{`(${getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            )})`}</div>
                        )}
                    </Button>
                </div>
            );
        } else if (addProductMethod === ADDPRODUCTMETHODS()[4].name) {
            return (
                <div style={{ display: 'inline-block' }}>
                    <Button
                        id={'surgery-surgeryfooter-addtocart-button'}
                        show={true}
                        // primary={
                        //     getQuantityCount(
                        //         productWithIsPlaceHolderSet &&
                        //             productWithIsPlaceHolderSet?.length > 0
                        //             ? productWithIsPlaceHolderSet?.filter(
                        //                   (item) =>
                        //                       selectedItems.some(
                        //                           (data) => data.cfn != item.cfn
                        //                       )
                        //               )
                        //             : selectedItems
                        //     ) > 0
                        // }
                        disabled={
                            getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            ) === 0
                        }
                        variant={
                            getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            ) > 0
                                ? ButtonStyles?.primary
                                : ButtonStyles?.disabled
                        }
                        width={
                            isLanguageChanged && selectedItems.length > 0
                                ? '197px'
                                : '178px'
                        }
                        mobileWidth={'289px'}
                        height={'38px'}
                        clicked={() => {
                            try {
                                dispatch(
                                    validateProducts({
                                        products:
                                            validateProductsQuickOrder(
                                                selectedItems
                                            ),
                                        orderType: 'ZLC',
                                        isFromSurgery: true,
                                    })
                                );
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        margin={'5px'}
                    >
                        <div style={{ paddingRight: '4px' }}>
                            {t('equity.surgery.addToCart')}
                        </div>
                        {selectedItems.length > 0 && (
                            <div>{`(${getQuantityCount(
                                productWithIsPlaceHolderSet &&
                                    productWithIsPlaceHolderSet?.length > 0
                                    ? productWithIsPlaceHolderSet?.filter(
                                          (item) =>
                                              selectedItems.some(
                                                  (data) => data.cfn != item.cfn
                                              )
                                      )
                                    : selectedItems
                            )})`}</div>
                        )}
                    </Button>
                </div>
            );
        } else {
            return (
                <>
                    {' '}
                    <Button
                        id={'surgery-surgeryfooter-cancel-button'}
                        show={true}
                        // secondary={true}
                        variant={ButtonStyles?.cancel}
                        width={isLanguageChanged ? '110px' : '95px'}
                        height={'38px'}
                        margin={'5px'}
                        //cancel={true}
                        clicked={() => setCancel(!cancel)}
                    >
                        {t('reportUsage.reportUsageFooterbuttons.cancelButton')}
                    </Button>
                    {(isModifySurgery() && ((orderStatus === 'In Process') || (orderStatus === '処理中') || (orderStatus === 'Usage Pending'))) ? (
                        <Button
                            id={'modify-surgery-surgeryfooter-submit-button'}
                            show={currentActivity === 'Submit' ? false : true}
                            variant={
                                disabled
                                    ? ButtonStyles?.disabled
                                    : ButtonStyles?.surgery
                            }
                            width={'95px'}
                            height={'38px'}
                            clicked={() => {
                                try {
                                    if (isModifySurgery()) {
                                        //check for delivery eligibility
                                        if (deliveryCheckEdit === VISIBLE) {
                                            setIsCheckingReviewEligibility(
                                                true
                                            );
                                            const deliveryCheckPayload = {
                                                orderType: 'ZLC',
                                                action: 'edit',
                                                myCaseRef: myCaseRefId,
                                            };
                                            dispatch(
                                                getCheckOrderActionEligibility(
                                                    deliveryCheckPayload
                                                )
                                            );
                                            return;
                                        }
                                    }
                                    if (!disabled) {
                                        dispatch(stopTimer());

                                        setViewSurgerySuccess(true);
                                        return;
                                    }
                                    setViewSurgerySuccess(true);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            // surgery={!disabled}
                            disabled={disabled}
                            margin={'5px'}
                            fontSize={'15px'}
                            throttle={300}
                        >
                            {t('noUsageToReport.submitButton')}
                        </Button>
                    ) : (
                    <Button
                        id={'surgery-surgeryfooter-saveandexit-button'}
                        show={true}
                        // secondary={
                        //     currentActivity === SCHEDULESURGERYSTEPS[3]
                        //         ? true
                        //         : currentActivity === SCHEDULESURGERYSTEPS[1]
                        //         ? true
                        //         : !disabled
                        // }
                        width={isLanguageChanged ? '100px' : '95px'}
                        height={'38px'}
                        margin={'5px'}
                        // clicked={() => setsaveAndExit(!saveAndExit)}
                        clicked={() => {
                            try {
                                if (isModifySurgery()) {
                                    //check for delivery eligibility
                                    if (deliveryCheckEdit === VISIBLE) {
                                        setIsSaveAndExitClicked(true);
                                        const deliveryCheckPayload = {
                                            orderType: 'ZLC',
                                            action: 'edit',
                                            myCaseRef: myCaseRefId,
                                        };
                                        dispatch(
                                            getCheckOrderActionEligibility(
                                                deliveryCheckPayload
                                            )
                                        );
                                        return;
                                    }
                                }
                                saveSurgeryAndExit();
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        disabled={
                            currentActivity === SCHEDULESURGERYSTEPS[0] ||
                            (currentActivity === SCHEDULESURGERYSTEPS[2] &&
                                sameBatchAllocationError)
                                ? disabled
                                : false
                        }
                        variant={
                            currentActivity === SCHEDULESURGERYSTEPS[3] ||
                            currentActivity === SCHEDULESURGERYSTEPS[1] ||
                            currentActivity === SCHEDULESURGERYSTEPS[2] ||
                            !disabled
                                ? ButtonStyles?.secondary
                                : currentActivity === SCHEDULESURGERYSTEPS[0] ||
                                  (currentActivity ===
                                      SCHEDULESURGERYSTEPS[2] &&
                                      sameBatchAllocationError)
                                ? ButtonStyles?.disabled
                                : ButtonStyles?.disabled
                        }
                    >
                        <div style={{ whiteSpace: 'nowrap' }}>
                            {t('equity.equityFooter.saveAndExitButton')}
                        </div>
                    </Button>
                    )}
                    {showNext &&
                    (!tissuePO ||
                        !nonTissuePO ||
                        currentSelectedIndex === 0 ||
                        disabled) ? (
                        <>
                                <Button
                                    id={'surgery-surgeryfooter-next-button'}
                                    show={true}
                                    variant={disabled ? ButtonStyles?.disabled : ButtonStyles?.primary}
                                    disabled={disabled}
                                    width={'95px'}
                                    height={'38px'}
                                    margin={'5px'}
                                    clicked={() => {
                                        try {
                                        if (currentSelectedIndex === 0) {
                                            checkPoNumberNonTissue();
                                            if (nonTissuePO) {
                                            dispatch(
changeShippingSegmentIndex(
                                                        currentSelectedIndex === 1
                                                            ? 0
                                                            : 1
                                                    )
                                                );
                                            }
                                        }
                                        if (currentSelectedIndex === 1) {
                                            checkPoNumberTissue();
                                            if (tissuePO) {
                                                dispatch(
                                                    changeShippingSegmentIndex(
                                                        currentSelectedIndex ===
                                                            1
                                                            ? 0
                                                            : 1
                                                    )
                                                );
                                            }
                                        }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    {t(
                                        'scheduleSurgery.surgery.SurgeryFooter.nextBtn'
                                    )}
                                </Button>
                        </>
                    ) : (
                        <>
                            {!showSubmit ? (
                                <Button
                                    id={'surgery-surgeryfooter-continue-button'}
                                    show={true}
                                    //surgeryNotesDisabled={true}
                                    variant={
                                        disabled
                                            ? ButtonStyles?.disabled
                                            : ButtonStyles?.primary
                                    }
                                    //primary={!disabled}
                                    width={'95px'}
                                    height={'38px'}
                                    clicked={() => {
                                        try {
                                            if (isModifySurgery()) {
                                                //check for delivery eligibility
                                                if (
                                                    deliveryCheckEdit ===
                                                    VISIBLE
                                                ) {
                                                    setIsCheckingEligibility(
                                                        true
                                                    );
                                                    const deliveryCheckPayload =
                                                        {
                                                            orderType: 'ZLC',
                                                            action: 'edit',
                                                            myCaseRef:
                                                                myCaseRefId,
                                                        };
                                                    dispatch(
                                                        getCheckOrderActionEligibility(
                                                            deliveryCheckPayload
                                                        )
                                                    );
                                                    return;
                                                }
                                            }
                                            if (
                                                currentActivity ===
                                                SCHEDULESURGERYSTEPS[2]
                                            ) {
                                                checkPoNumber();
                                                if (tissuePO && nonTissuePO) {
                                                    dispatch(
                                                        setProgressBarStatus(
                                                            currentActivity
                                                        )
                                                    );
                                                    if (
                                                        currentActivity ===
                                                        SCHEDULESURGERYSTEPS[3]
                                                    ) {
                                                        setViewSurgerySuccess(
                                                            true
                                                        );
                                                        return;
                                                    }

                                                    if (
                                                        !nonTissueSetsForInventoryShipping.nonInventoryShipping &&
                                                        currentActivity ===
                                                            SCHEDULESURGERYSTEPS[2] &&
                                                        nonTissueSetsForInventoryShipping
                                                            .setsList.length > 0
                                                    )
                                                        dispatch(
                                                            updateCartDataShipping(
                                                                {
                                                                    shippingRequirement:
                                                                        nonTissueSetsForInventoryShipping.nonInventoryShipping,
                                                                },
                                                                nonTissueSetsForInventoryShipping.setsList.map(
                                                                    (set) =>
                                                                        set.productKey
                                                                )
                                                            )
                                                        );
                                                }
                                            } else if (!disabled) {
                                                const { autoAddItems } =
                                                    computeAutoAddItems({
                                                        cartProducts:
                                                            cartData?.products ??
                                                            [],
                                                        addedItemsState,
                                                        addItemRules,
                                                        addItemData,
                                                    });
                                                if (
                                                    currentActivity ===
                                                        SCHEDULESURGERYSTEPS[1] &&
                                                    autoAddItems.length > 0
                                                ) {
                                                    setPopupItems(autoAddItems);
                                                    addItemToCart(autoAddItems);
                                                    setPendingPopup(true);
                                                } else {
                                                    continueClick();
                                                }
                                            }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    disabled={disabled || isCheckingEligibility}
                                    margin={'5px'}
                                    fontSize={'15px'}
                                >
                                    {t(
                                        'scheduleSurgery.surgery.notifications.UnapprovedItemsNotAllowed.continueButton'
                                    )}
                                </Button>
                            ) : (
                                <Button
                                    id={'surgery-surgeryfooter-submit-button'}
                                    show={true}
                                    // surgeryNotesDisabled={true}
                                    // surgery={
                                    //     !reviewMandatoryFields?.reviewAcknowledgment ||
                                    //     (setCount?.length === 0 &&
                                    //         cartProductsLength)
                                    //         ? true
                                    //         : surgeryVisualInspection ===
                                    //           VISIBLE
                                    //         ? visualInspectionAcknowledgement
                                    //         : true
                                    // }
                                    variant={
                                        (
                                            (setCount?.length === 0 &&
                                                cartProductsLength)
                                                ? true
                                                : surgeryVisualInspection ===
                                                  VISIBLE
                                                ? visualInspectionAcknowledgement
                                                : true
                                        )
                                            ? ButtonStyles?.surgery
                                            : disabled
                                            ? ButtonStyles?.disabled
                                            : ButtonStyles?.surgeryNotesDisabled
                                    }
                                    width={'95px'}
                                    height={'38px'}
                                    clicked={() => {
                                        try {
                                            if (isModifySurgery()) {
                                                //check for delivery eligibility
                                                if (
                                                    deliveryCheckEdit ===
                                                    VISIBLE
                                                ) {
                                                    setIsCheckingReviewEligibility(
                                                        true
                                                    );
                                                    const deliveryCheckPayload =
                                                        {
                                                            orderType: 'ZLC',
                                                            action: 'edit',
                                                            myCaseRef:
                                                                myCaseRefId,
                                                        };
                                                    dispatch(
                                                        getCheckOrderActionEligibility(
                                                            deliveryCheckPayload
                                                        )
                                                    );
                                                    return;
                                                }
                                            }
                                            if (!disabled) {
                                                // Stop timer and calculate duration
                                                dispatch(stopTimer());
                                                // dispatch(
                                                //     setProgressBarStatus(
                                                //         currentActivity
                                                //     )
                                                // );
                                                if (
                                                    currentActivity ===
                                                    SCHEDULESURGERYSTEPS[0]
                                                ) {
                                                    dispatch(
                                                        disableSurgeryDate(true)
                                                    );
                                                    dispatch(
                                                        storeAddItemData([])
                                                    );
                                                    if (
                                                        new Date(
                                                            new Date(
                                                                surgeryDateTime
                                                            ).setHours(
                                                                0,
                                                                0,
                                                                0,
                                                                0
                                                            )
                                                        ).getTime() ===
                                                        new Date().setHours(
                                                            0,
                                                            0,
                                                            0,
                                                            0
                                                        )
                                                    ) {
                                                        dispatch(
                                                            currentSurgeryDateSelected(
                                                                true
                                                            )
                                                        );
                                                    } else {
                                                        dispatch(
                                                            currentSurgeryDateSelected(
                                                                false
                                                            )
                                                        );
                                                    }
                                                }
                                                if (
                                                    currentActivity ===
                                                    SCHEDULESURGERYSTEPS[3]
                                                ) {
                                                    setViewSurgerySuccess(true);
                                                    return;
                                                }
                                            }
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    // surgery={!disabled}
                                    disabled={disabled}
                                    margin={'5px'}
                                    fontSize={'15px'}
                                    throttle={300}
                                >
                                    {t('noUsageToReport.submitButton')}
                                </Button>
                            )}
                        </>
                    )}
                </>
            );
        }
    };
    return (
        <>
            <BottomNavigation
                justifyContent="space-around"
                moblieJustifyContent="space-evenly"
                padding={customStyle.padding}
                right={'0'}
                position={customStyle.position}
                width={customStyle.width}
                zIndex={zIndex}
            >
                {
                    <BottomNavigationButtonContainer
                        smallJustifyContent={'center'}
                        justifyContent={justifyContent}
                        tabletPortraitMargin={tabletPortraitMargin}
                        addIosPadding={addIosPadding}
                        deskMarginRight={deskMarginRight}
                        isFromSearchSelectedTemplate={isFromSearchSelectedTemplate}
                    >
                        {getButtonsBasedOnActivity(
                            viewTemplate,
                            selectedItems,
                            disabled,
                            createTemplate,
                            addProductMethod,
                            productSearchPagination
                        )}
                    </BottomNavigationButtonContainer>
                }
            </BottomNavigation>
            {cancel ? (
                <UnsavedChanges
                    onDiscard={() => handleDiscardChanges()}
                    onClose={() => {
                        try {
                            setCancel(!cancel);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            ) : null}
            {/* Only non-tissue sets can be added */}
            {onlyNonTissueSets && (
                <NoInventoryShippingNonTissueSet
                    onClose={() => setOnlyNonTissueSets(false)}
                />
            )}
            {showAddPopup && popupItems?.length > 0 && (
                <Popup
                    onClick={() => setShowAddPopup(!showAddPopup)}
                    id={'surgery-footer-notice-popup'}
                    mobileWidth={'96%'}
                    borderRadius={'10px'}
                    width={'450px'}
                    backgroundColor={'white'}
                    margin={'0 auto'}
                    height={'277px'}
                >
                    <ImportantNotice>
                        {t(
                            'scheduleSurgery.surgery.notifications.businessRules.importantNotice'
                        )}
                    </ImportantNotice>

                    <MsgText>
                        <strong>
                            {t(
                                'scheduleSurgery.surgery.notifications.businessRules.addedFollowingItemsToCart'
                            )}
                        </strong>{' '}
                        {isLanguageChanged
                            ? ''
                            : t(
                                  'scheduleSurgery.surgery.notifications.businessRules.msg1'
                              )}
                        {
                            <ResponsiveSpan>
                                {isLanguageChanged
                                    ? t(
                                          'scheduleSurgery.surgery.notifications.businessRules.msg1'
                                      )
                                    : t(
                                          'scheduleSurgery.surgery.notifications.businessRules.msg2'
                                      )}
                            </ResponsiveSpan>
                        }
                    </MsgText>

                    <ProductList>
                        {popupItems.map((product, index) =>
                            !isLanguageChanged ? (
                                <ProductItem key={index}>
                                    <strong>
                                        {t(
                                            'equity.common.templateDetails.item'
                                        )}{' '}
                                        {product.B}
                                    </strong>{' '}
                                    {t(
                                        'scheduleSurgery.surgery.notifications.businessRules.msg3'
                                    )}{' '}
                                    {product.A}.
                                </ProductItem>
                            ) : (
                                <ProductItem key={index}>
                                    {t(
                                        'scheduleSurgery.surgery.notifications.businessRules.msg4'
                                    )
                                        .replace('${product.A}', product.A)
                                        .replace('${product.B}', product.B)}
                                </ProductItem>
                            )
                        )}
                    </ProductList>

                    <ButtonTexts>
                        <Button
                            id={'surgery-surgeryfooter-returntocart-button'}
                            show={true}
                            variant={ButtonStyles?.secondary}
                            // primary={!disabled}
                            clicked={() => {
                                setShowAddPopup(false);
                                setPopupItems([]);
                            }}
                            width={'198px'}
                            margin={'5px'}
                            secondary={true}
                            style={{
                                backgroundColor: 'white',
                                color: '#1A237E',
                                border: '1px solid #1A237E',
                                '@media (max-width: 576px)': {
                                    width: '100%',
                                    margin: '5px 0',
                                },
                            }}
                        >
                            <ReturnToCartText>
                                {t(
                                    'scheduleSurgery.surgery.notifications.businessRules.returnToCart'
                                )}
                            </ReturnToCartText>
                        </Button>
                        <Button
                            id={
                                'surgery-surgeryfooter-acceptandcontinue-button'
                            }
                            show={true}
                            // primary={disabled}
                            variant={ButtonStyles?.primary}
                            //  primary={true}
                            clicked={() => {
                                try {
                                    setPopupItems([]);
                                    setShowAddPopup(false);
                                    continueClick();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            width={'209px'}
                            margin={'5px'}
                            fontSize={'14px'}
                            style={{
                                '@media (max-width: 576px)': {
                                    width: '100%',
                                    margin: '5px 0',
                                },
                            }}
                        >
                            <AcceptContinueText>
                                {t(
                                    'scheduleSurgery.surgery.notifications.businessRules.acceptAndContinue'
                                )}
                            </AcceptContinueText>
                        </Button>
                    </ButtonTexts>
                </Popup>
            )}
            {showDeliveryCheckMessage &&
                isModifySurgery() &&
                !isAllowed &&
                statusCode === '13201' && (
                    <MessageTemplate
                        isDeliveryCheck={true}
                        onClose={() => {
                            try {
                                handleCloseDeliveryCheckPopUp();
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        content={'edit'}
                        width={'100%'}
                        marginB={'25px'}
                        position={'static'}
                        height={'auto'}
                        title={t('orders.deliveryCheck.editTitle')}
                        fontWeight={'800'}
                    />
                )}
        </>
    );
}

export default SurgeryFooter;

const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};
    margin-right: ${(props) =>
        props.deskMarginRight ? props.deskMarginRight : '15px'};

    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
        /* For ipadPro landscape layouts only */
        margin-right: ${({isFromSearchSelectedTemplate}) => isFromSearchSelectedTemplate ? '41px' : '36px'};
    }
    @media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
        /* For ipad landscape layouts only */
        margin-right: 46px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
            smallJustifyContent ? smallJustifyContent : 'center'};
        margin: ${(props) =>
            props.tabletPortraitMargin ? props.tabletPortraitMargin : ''};
    }

    ${media.mobileDevice`
        justify-content: space-evenly;
        margin-right: auto !important;
        padding-bottom:${({ addIosPadding }) =>
            addIosPadding
                ? ENVIRONMENTVARIABLE
                    ? 'calc(2*env(safe-area-inset-bottom))'
                    : 'unset'
                : 'unset'}
    `}
`;
